import axios from 'axios'

const API_BASE_URL = 'https://api.euromix-brand.com'

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

// Admin API functions
export const adminAPI = {
  // Auth
  login: (email, password) => api.post('/api/admin/login', { email, password }),
  
  // Users
  getUsers: (params = '') => api.get(`/api/admin/users${params ? '?' + params : ''}`),
  updateUser: (id, data) => api.put(`/api/admin/users/${id}`, data),
  deleteUser: (id) => api.delete(`/api/admin/users/${id}`),
  getBirthdayUsers: () => api.get('/api/admin/users/birthday-today'),
  
  // Regions
  getRegions: () => api.get('/api/admin/regions'),
  createRegion: (data) => api.post('/api/admin/regions', data),
  updateRegion: (id, data) => api.put(`/api/admin/regions/${id}`, data),
  deleteRegion: (id) => api.delete(`/api/admin/regions/${id}`),
  getRegionStats: () => api.get('/api/admin/regions/stats'),
  
  // Push Notifications
  getNotifications: () => api.get('/api/admin/push-notifications'),
  createNotification: (data) => api.post('/api/admin/push-notifications', data),
  updateNotification: (id, data) => api.put(`/api/admin/push-notifications/${id}`, data),
  deleteNotification: (id) => api.delete(`/api/admin/push-notifications/${id}`),
  getNotificationUsers: (id, params = '') => api.get(`/api/admin/push-notifications/${id}/users${params ? '?' + params : ''}`),
  getNotificationStats: (id) => api.get(`/api/admin/push-notifications/${id}/stats`),
  
  // Banners
  getBanners: () => api.get('/api/admin/banners'),
  createBanner: (data) => api.post('/api/admin/banners', data),
  createBannerWithFile: (formData) => api.post('/api/admin/banners/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  updateBanner: (id, data) => api.put(`/api/admin/banners/${id}`, data),
  updateBannerWithFile: (id, formData) => api.put(`/api/admin/banners/${id}/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  deleteBanner: (id) => api.delete(`/api/admin/banners/${id}`),
  reorderBanners: (ids) => api.post('/api/admin/banners/reorder', { bannerIds: ids }),
  
  // Stats
  getStats: () => api.get('/api/admin/stats'),
  
  // Sync (for logs)
  getSyncStats: () => api.get('/api/sync/stats'),
  getRecentErrors: () => api.get('/api/sync/recent-errors'),
  getUnsyncedUsers: () => api.get('/api/sync/unsynced'),
  bulkUpdateFrom1C: (data) => api.post('/api/sync/bulk-update-from-1c', data),
  markSynced: (userIds) => api.post('/api/sync/mark-synced', { userIds })
}

export default api
